import { FC, ReactNode } from 'react';
import { Providers } from './components/app/Providers';
import { App } from './components/app/App';

const { VITE_ADOBE_LAUNCH_SCRIPT, VITE_AWS_WAF_URL } = import.meta.env;

type ReactAppProps = {
  LDProvider: FC<{ children: ReactNode }>;
};

export const ReactApp = ({ LDProvider }: ReactAppProps) => {
  return (
    <>
      <Providers LDProvider={LDProvider}>
        <App />
      </Providers>

      <script src={VITE_AWS_WAF_URL} async></script>
      <script src={VITE_ADOBE_LAUNCH_SCRIPT} async></script>
    </>
  );
};
